// ABCI Company Mock Data

export const companyInfo = {
  name: "ABCI",
  fullName: "Artificial Blockchain Intelligence",
  tagline: "A Next Generation Platform",
  description: "We deliver cutting-edge AI, Blockchain, Web and Game solutions that transform businesses and drive innovation in the digital era.",
  email: "support@abci.tech",
  phone: "+91 9876543210",
  address: "Gujarat, India",
  regions: ["North America", "South Asia", "Europe"],
  founded: "2020",
  logo: "/abci-logo.png",
  logoIcon: "/abci-logo.png",
  social: {
    linkedin: "https://linkedin.com/company/artificial-blockchain-intelligence-abci",
  }
};

export const services = {
  ai: [
    {
      id: "agentic-ai",
      title: "Agentic AI Development",
      description: "Build autonomous AI agents that reason, plan, and execute complex tasks independently. Our agentic AI solutions leverage the latest LLM technologies to create intelligent systems that work alongside your team.",
      icon: "Bot"
    },
    {
      id: "ai-chatbots",
      title: "AI Chatbots & Virtual Assistants",
      description: "Deploy intelligent conversational AI powered by GPT-4, Claude, and custom fine-tuned models. Create seamless customer experiences with 24/7 automated support.",
      icon: "MessageSquareText"
    },
    {
      id: "ml-solutions",
      title: "Machine Learning Solutions",
      description: "Custom ML models for predictive analytics, anomaly detection, and data-driven decision making. From training to deployment, we handle the complete ML lifecycle.",
      icon: "Brain"
    },
    {
      id: "computer-vision",
      title: "Computer Vision & Image Processing",
      description: "Advanced image recognition, object detection, and visual AI systems. Transform visual data into actionable insights with our cutting-edge CV solutions.",
      icon: "Eye"
    },
    {
      id: "nlp",
      title: "Natural Language Processing",
      description: "Unlock the power of text with sentiment analysis, entity extraction, document processing, and language understanding solutions.",
      icon: "Languages"
    },
    {
      id: "recommendation",
      title: "AI Recommendation Systems",
      description: "Personalized recommendation engines that boost engagement and conversion. Powered by deep learning and real-time user behavior analysis.",
      icon: "Sparkles"
    }
  ],
  blockchain: [
    {
      id: "smart-contracts",
      title: "Smart Contract Development",
      description: "Secure, audited smart contracts on Ethereum, Solana, Polygon, and other major chains. From DeFi protocols to NFT marketplaces, we build robust on-chain logic.",
      icon: "FileCode"
    },
    {
      id: "contract-audit",
      title: "Smart Contract Audit",
      description: "Comprehensive security audits to identify vulnerabilities and ensure your contracts are battle-tested. Protect your users and assets with our expert review.",
      icon: "ShieldCheck"
    },
    {
      id: "dapps",
      title: "DApps Development",
      description: "Full-stack decentralized applications with intuitive UIs and seamless Web3 integration. Build the future of trustless applications with us.",
      icon: "Blocks"
    },
    {
      id: "defi",
      title: "DeFi Solutions",
      description: "Custom DeFi protocols including DEXs, lending platforms, yield aggregators, and staking solutions. Architecting the future of decentralized finance.",
      icon: "Coins"
    },
    {
      id: "nft",
      title: "NFT Development",
      description: "End-to-end NFT solutions - from smart contracts to marketplaces. Create, mint, and trade digital assets with our comprehensive NFT platform development.",
      icon: "ImageIcon"
    },
    {
      id: "blockchain-consulting",
      title: "Blockchain Consulting",
      description: "Strategic guidance on blockchain adoption, architecture design, and technology selection. Navigate the Web3 landscape with expert advisors.",
      icon: "Lightbulb"
    }
  ],
  web: [
    {
      id: "full-stack",
      title: "Modern Full-Stack Development",
      description: "High-performance applications built with React, Next.js, and Node.js. We deliver seamless, scalable digital experiences tailored to your business needs.",
      icon: "Globe"
    },
    {
      id: "dotnet-apps",
      title: "Enterprise .NET Solutions",
      description: "Robust, scalable enterprise applications powered by C# and .NET. We specialize in building secure, high-concurrency systems for complex business requirements.",
      icon: "Cpu"
    },
    {
      id: "php-solutions",
      title: "Professional PHP Web Dev",
      description: "Dynamic and secure web solutions using PHP and modern frameworks like Laravel. From custom web portals to complex back-ends, we deliver reliability.",
      icon: "Code2"
    },
    {
      id: "core-web",
      title: "Core Web Technologies",
      description: "Expertise in the heart of the web: HTML5, CSS3, and JavaScript (ES6+). We build high-quality, semantic, and pixel-perfect front-ends for every device.",
      icon: "FileCode2"
    },
    {
      id: "ecommerce",
      title: "E-Commerce Excellence",
      description: "Feature-rich online stores with secure payments and intuitive UX. Convert visitors into customers with our high-conversion shop designs.",
      icon: "ShoppingCart"
    },
    {
      id: "uiux",
      title: "Premium UI/UX Design",
      description: "User-centric designs that blend beauty with functionality. Create intuitive interfaces that enhance your brand and keep users engaged.",
      icon: "Palette"
    },
    {
      id: "cloud-web",
      title: "Cloud-Native Architecture",
      description: "Web solutions integrated with AWS, GCP, and Azure for global reach. Build resilient applications that scale automatically with your growth.",
      icon: "Cloud"
    },
    {
      id: "performance",
      title: "Speed & SEO Optimization",
      description: "Lightning-fast loads and Core Web Vitals perfection. Improve your search rankings and user retention with our specialized performance tuning.",
      icon: "Zap"
    },
    {
      id: "cms",
      title: "Custom CMS Development",
      description: "Tailored content management systems like WordPress or custom-built panels. Empower your team to manage content effortlessly and securely.",
      icon: "Layout"
    }
  ],
  game: [
    {
      id: "3d-games",
      title: "3D/2D Game Development",
      description: "Immersive gaming experiences with stunning visuals and polished mechanics. From mobile hits to desktop masterpieces, we bring your vision to life.",
      icon: "Gamepad2"
    },
    {
      id: "multiplayer",
      title: "Multiplayer Infrastructure",
      description: "Robust real-time multiplayer systems with low latency and high scalability. Connect players globally with our advanced networking solutions.",
      icon: "Users"
    },
    {
      id: "mobile-gaming",
      title: "Mobile Game Excellence",
      description: "Engaging and addictive mobile games optimized for iOS and Android. We focus on performance and retention-driven gameplay mechanics.",
      icon: "Smartphone"
    },
    {
      id: "metaverse",
      title: "Metaverse & VR/AR",
      description: "Step into the future with immersive VR/AR experiences and metaverse environments. We build worlds that redefine digital interaction.",
      icon: "VrViewer"
    },
    {
      id: "game-engines",
      title: "Unity Engine Expertise",
      description: "Professional development using the industry-leading Unity engine. We leverage the full power of Unity to deliver high-quality graphics and physics.",
      icon: "Cpu"
    },
    {
      id: "blockchain-gaming",
      title: "Web3 & NFT Gaming",
      description: "The next generation of gaming with Play-to-Earn mechanics and NFT integration. Empower players with true ownership of digital assets.",
      icon: "Trophy"
    }
  ]
};

export const features = [
  {
    title: "Cutting-Edge Technology",
    description: "We stay ahead of the curve, implementing the latest advancements in AI and Blockchain.",
    icon: "Zap"
  },
  {
    title: "Global Expertise",
    description: "Our team serves clients across North America, South Asia, and Europe with deep domain knowledge.",
    icon: "Globe"
  },
  {
    title: "Security First",
    description: "Every solution we build prioritizes security, from smart contract audits to AI model safety.",
    icon: "Lock"
  },
  {
    title: "End-to-End Solutions",
    description: "From ideation to deployment and maintenance, we provide complete development lifecycle support.",
    icon: "Layers"
  }
];

export const stats = [
  { value: "50+", label: "Projects Delivered" },
  { value: "30+", label: "Happy Clients" },
  { value: "3", label: "Countries Served" },
  { value: "5+", label: "Years Experience" }
];

export const testimonials = [
  {
    id: 1,
    name: "Marco Rossi",
    role: "CTO, TechVentures Italy",
    content: "ABCI delivered an exceptional DeFi platform that exceeded our expectations. Their expertise in smart contract development is unmatched.",
    avatar: "MR"
  },
  {
    id: 2,
    name: "Priya Sharma",
    role: "Founder, DataMinds India",
    content: "The AI recommendation system ABCI built increased our user engagement by 40%. Their team truly understands machine learning at scale.",
    avatar: "PS"
  },
  {
    id: 3,
    name: "Jean-Pierre Dubois",
    role: "Director, InnovateFrance",
    content: "Working with ABCI on our blockchain supply chain solution was a game-changer. Professional, knowledgeable, and delivered on time.",
    avatar: "JD"
  }
];

export const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "About", href: "#about" },
  { label: "Tech Stack", href: "#tech-stack" },
  { label: "Contact", href: "#contact" }
];
